import { Settings } from '../comps/Settings';
import { MgRouter } from '../mg/MgRouter';
import { AdmPretemplateItemPage } from '../pages/adm/AdmPretemplateItemPage';
import { AdmPretemplatePage } from '../pages/adm/AdmPretemplatePage';
import { AdmSupplierItemPage } from '../pages/adm/AdmSupplierItemPage';
import { AdmSupplierPage } from '../pages/adm/AdmSupplierPage';
import { AdmTemplateItemPage } from '../pages/adm/AdmTemplateItemPage';
import { AdmTemplatePage } from '../pages/adm/AdmTemplatePage';
import { AdmUserPage } from '../pages/adm/AdmUserPage';
import { DbStatPage } from '../pages/adm/DbStatPage';
import { AdsPage } from '../pages/ads/AdsPage';
import { GDashboard } from '../pages/dashboard/GDashboard';
import { LDashboard } from '../pages/dashboard/LDashboard';
import { AdmAdPage } from '../pages/ges/ad/AdmAdPage';
import { AdmCouponPage } from '../pages/ges/AdmCouponPage';
import { HarmoPage } from '../pages/ges/harmo/HarmoPage';
import { BrandPage } from '../pages/ges/obsolete/BrandPage';
import { OutletPage } from '../pages/ges/outlet/OutletPage';
import { SendMessagePage } from '../pages/ges/SendMessagePage';
import { MessagePage } from '../pages/messages/MessagePage';
import { Profile } from '../pages/misc/Profile';
import { OrderPage } from '../pages/order/OrderPage';
import { LTemplates } from '../pages/ordering/LTemplates';
import { GReminders } from '../pages/reminders/GReminders';
import { TeamPage } from '../pages/team/TeamPage';
import { IOmnistore } from './Omnistore';

const appPages = {
	GDashboard: GDashboard,
	LDashboard: LDashboard,
	MessagePage: MessagePage,
	OrderPage: OrderPage,
	AdsPage: AdsPage,
	LTemplates: LTemplates,
	SupplierOffers: LTemplates,
	GReminders: GReminders,
	LCatalog: LTemplates,
	Checkout: LTemplates,
	Profile: Profile,
	TeamPage: TeamPage,
	Settings: Settings,
};

const admPages = {
	AdmUserPage: AdmUserPage,
	AdmSupplierPage: AdmSupplierPage,
	AdmSupplierItemPage: AdmSupplierItemPage,
	HarmoPage: HarmoPage,
	BrandPage: BrandPage,
	DbStatPage: DbStatPage,
	AdmCouponPage: AdmCouponPage,
	AdmAdPage: AdmAdPage,
	OutletPage: OutletPage,
	SendMessagePage: SendMessagePage,
	AdmPretemplatePage: AdmPretemplatePage,
	AdmPretemplateItemPage: AdmPretemplateItemPage,
	AdmTemplatePage: AdmTemplatePage,
	AdmTemplateItemPage: AdmTemplateItemPage,
};

const displays = {
	branchId: (omnistore: IOmnistore, id: number) => omnistore.multirepo.branchRepo.byId(id)?.name || '',
	supplierId: (omnistore: IOmnistore, id: number) => omnistore.multirepo.allSupplierRepo.byId(id)?.name || '',
	pretemplateId: (omnistore: IOmnistore, id: number) => '' + id,
	masterId: (omnistore: IOmnistore, id: number) => omnistore.multirepo.masterSupplierRepo.byId(id)?.name || '',
	customerNo: (omnistore: IOmnistore, customerNo: string) => customerNo,
};

const toBreadcrumbMap = {
	GDashboard: '=general ~page',
	OrderPage: '=general ~page',
	AdsPage: '=general ~page',

	LDashboard: '=location ~branchId ~page',
	LTemplates: '=location ~branchId ~page ~supplierId',
	SupplierOffers: '=location ~branchId ^LTemplates ~page ~supplierId',
	Checkout: '=location ~branchId ^LTemplates ~page ~supplierId',
	LCatalog: '=location ~branchId ^LTemplates ~page ~supplierId',
	TeamPage: '=location ~branchId ~page',

	MessagePage: '~page',
	Profile: '~page',
	Settings: '~page',

	HarmoPage: '=dataManagement ~page ~masterId',
	OutletPage: '=dataManagement ~page',
	AdmAdPage: '=adsManagement ~page',
	SendMessagePage: '=adsManagement ~page',
	AdmCouponPage: '=adsManagement ~page',
	BrandPage: '~page',
	AdmUserPage: '~page',
	AdmSupplierPage: '~page',
	AdmSupplierItemPage: '~page ~supplierId',
	AdmPretemplatePage: '~page ~supplierId',
	AdmPretemplateItemPage: '~page ~supplierId ~customerNo ~pretemplateId',
	AdmTemplatePage: '~page ~supplierId ~branchId',
	AdmTemplateItemPage: '~page ~supplierId ~branchId',
};

export class LocationStore {
	private readonly router: MgRouter<keyof typeof displays>;

	constructor() {
		this.router = new MgRouter<keyof typeof displays>(
			toBreadcrumbMap,
			displays,
			{...appPages, ...admPages} as any, //TODO
		);
	}

	get componentClass() {
		return this.router.component;
	}

	get page() {
		return this.router.page;
	}

	setPage(page: string) {
		this.router.page = page;
	}

	get branchId() : number {
		return +this.router.getVar('branchId');
	}

	setBranchId(branchId: number) {
		this.router.setVar('branchId', branchId);
	}

	get supplierId() : number {
		return +this.router.getVar('supplierId');
	}

	setSupplierId(supplierId: number) {
		this.router.setVar('supplierId', supplierId);
	}

	get customerNo() : string {
		return '' + this.router.getVar('customerNo');
	}

	setCustomerNo(customerNo: string) {
		this.router.setVar('customerNo', customerNo);
	}

	get masterId() : number {
		return +this.router.getVar('masterId');
	}

	setMasterId(masterId: number) {
		this.router.setVar('masterId', masterId);
	}

	get pretemplateId() : number {
		return +this.router.getVar('pretemplateId');
	}

	setPretemplateId(pretemplateId: number) {
		this.router.setVar('pretemplateId', pretemplateId);
	}

	get urlHash() {
		return this.router.urlHash;
	}

	applyUrl(url: string) {
		this.router.applyUrl(url);
	}

	get documentTitle() {
		return this.router.documentTitle;
	}

	get secret() {
		return this.router.secret;
	}

	clearSecret() {
		this.router.clearSecret();
	}

	get breadcrumbs() {
		return this.router.breadcrumbs;
	}

	breadcrumbsOf(varOverrides: Record<string, number|string>, suffix: Array<string>) {
		return this.router.breadcrumbsOf(varOverrides, suffix);
	}
}

export interface ILocationStore extends LocationStore {
}
